/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelFormuleLightDto } from './FunnelFormuleLightDto';
import {
    FunnelFormuleLightDtoFromJSON,
    FunnelFormuleLightDtoFromJSONTyped,
    FunnelFormuleLightDtoToJSON,
    FunnelFormuleLightDtoToJSONTyped,
} from './FunnelFormuleLightDto';
import type { FunnelProduitLightDto } from './FunnelProduitLightDto';
import {
    FunnelProduitLightDtoFromJSON,
    FunnelProduitLightDtoFromJSONTyped,
    FunnelProduitLightDtoToJSON,
    FunnelProduitLightDtoToJSONTyped,
} from './FunnelProduitLightDto';
import type { FunnelVariableDto } from './FunnelVariableDto';
import {
    FunnelVariableDtoFromJSON,
    FunnelVariableDtoFromJSONTyped,
    FunnelVariableDtoToJSON,
    FunnelVariableDtoToJSONTyped,
} from './FunnelVariableDto';
import type { TypeTunnel } from './TypeTunnel';
import {
    TypeTunnelFromJSON,
    TypeTunnelFromJSONTyped,
    TypeTunnelToJSON,
    TypeTunnelToJSONTyped,
} from './TypeTunnel';
import type { FunnelBeneficiaireDto } from './FunnelBeneficiaireDto';
import {
    FunnelBeneficiaireDtoFromJSON,
    FunnelBeneficiaireDtoFromJSONTyped,
    FunnelBeneficiaireDtoToJSON,
    FunnelBeneficiaireDtoToJSONTyped,
} from './FunnelBeneficiaireDto';
import type { GarantieTunnelListItemDto } from './GarantieTunnelListItemDto';
import {
    GarantieTunnelListItemDtoFromJSON,
    GarantieTunnelListItemDtoFromJSONTyped,
    GarantieTunnelListItemDtoToJSON,
    GarantieTunnelListItemDtoToJSONTyped,
} from './GarantieTunnelListItemDto';
import type { SupportTunnelDto } from './SupportTunnelDto';
import {
    SupportTunnelDtoFromJSON,
    SupportTunnelDtoFromJSONTyped,
    SupportTunnelDtoToJSON,
    SupportTunnelDtoToJSONTyped,
} from './SupportTunnelDto';
import type { TypeCommission } from './TypeCommission';
import {
    TypeCommissionFromJSON,
    TypeCommissionFromJSONTyped,
    TypeCommissionToJSON,
    TypeCommissionToJSONTyped,
} from './TypeCommission';

/**
 * Détail d'un tunnel. Sous-ensemble volontairement réduit de ReadTunnelDto : seuls les champs consommés par le back-office sont déclarés.
 * @export
 * @interface FunnelDetailDto
 */
export interface FunnelDetailDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelDetailDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelDetailDto
     */
    designation?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FunnelDetailDto
     */
    isActive?: boolean;
    /**
     * Même nom JSON que la liste admin. Fixé à la création, il ne se change que par une duplication.
     * @type {TypeTunnel}
     * @memberof FunnelDetailDto
     */
    tunnelType?: TypeTunnel;
    /**
     * 
     * @type {FunnelProduitLightDto}
     * @memberof FunnelDetailDto
     */
    produit?: FunnelProduitLightDto;
    /**
     * 
     * @type {FunnelFormuleLightDto}
     * @memberof FunnelDetailDto
     */
    formule?: FunnelFormuleLightDto;
    /**
     * 
     * @type {FunnelBeneficiaireDto}
     * @memberof FunnelDetailDto
     */
    beneficiaire?: FunnelBeneficiaireDto;
    /**
     * 
     * @type {string}
     * @memberof FunnelDetailDto
     */
    proprietaireId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelDetailDto
     */
    proprietaireDesignation?: string | null;
    /**
     * 
     * @type {Array<SupportTunnelDto>}
     * @memberof FunnelDetailDto
     */
    supports?: Array<SupportTunnelDto> | null;
    /**
     * 
     * @type {Array<GarantieTunnelListItemDto>}
     * @memberof FunnelDetailDto
     */
    garanties?: Array<GarantieTunnelListItemDto> | null;
    /**
     * 
     * @type {Array<FunnelVariableDto>}
     * @memberof FunnelDetailDto
     */
    variables?: Array<FunnelVariableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    fraisResiliation?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FunnelDetailDto
     */
    isListingActive?: boolean;
    /**
     * Le courtier peut être prélevé à la place du souscripteur (courtier encaisseur)
     * @type {boolean}
     * @memberof FunnelDetailDto
     */
    brokerCollectionAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    minCoeffCommercial?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    maxCoeffCommercial?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    plafondBienImmobilier?: number | null;
    /**
     * Lecture seule — non modifiable via UpdateFunnelCommand.
     * @type {number}
     * @memberof FunnelDetailDto
     */
    nbrPrelevMin?: number | null;
    /**
     * Lecture seule — non modifiable via UpdateFunnelCommand.
     * @type {number}
     * @memberof FunnelDetailDto
     */
    nbrPrelevMax?: number | null;
    /**
     * Lecture seule — non modifiable via UpdateFunnelCommand.
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneeDefault?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneeMax?: number | null;
    /**
     * 
     * @type {TypeCommission}
     * @memberof FunnelDetailDto
     */
    tauxComAnneeType?: TypeCommission;
    /**
     * 
     * @type {Array<number>}
     * @memberof FunnelDetailDto
     */
    tauxComAnneeValeurs?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneePlusDefault?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneePlusMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FunnelDetailDto
     */
    tauxComAnneePlusMax?: number | null;
    /**
     * 
     * @type {TypeCommission}
     * @memberof FunnelDetailDto
     */
    tauxComAnneePlusType?: TypeCommission;
    /**
     * 
     * @type {Array<number>}
     * @memberof FunnelDetailDto
     */
    tauxComAnneePlusValeurs?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FunnelDetailDto
     */
    partiesCommunes?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FunnelDetailDto
     */
    partiesPrivatives?: Array<number> | null;
}



/**
 * Check if a given object implements the FunnelDetailDto interface.
 */
export function instanceOfFunnelDetailDto(value: object): value is FunnelDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FunnelDetailDtoFromJSON(json: any): FunnelDetailDto {
    return FunnelDetailDtoFromJSONTyped(json, false);
}

export function FunnelDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'tunnelType': json['tunnelType'] == null ? undefined : TypeTunnelFromJSON(json['tunnelType']),
        'produit': json['produit'] == null ? undefined : FunnelProduitLightDtoFromJSON(json['produit']),
        'formule': json['formule'] == null ? undefined : FunnelFormuleLightDtoFromJSON(json['formule']),
        'beneficiaire': json['beneficiaire'] == null ? undefined : FunnelBeneficiaireDtoFromJSON(json['beneficiaire']),
        'proprietaireId': json['proprietaireId'] == null ? undefined : json['proprietaireId'],
        'proprietaireDesignation': json['proprietaireDesignation'] == null ? undefined : json['proprietaireDesignation'],
        'supports': json['supports'] == null ? undefined : ((json['supports'] as Array<any>).map(SupportTunnelDtoFromJSON)),
        'garanties': json['garanties'] == null ? undefined : ((json['garanties'] as Array<any>).map(GarantieTunnelListItemDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(FunnelVariableDtoFromJSON)),
        'fraisResiliation': json['fraisResiliation'] == null ? undefined : json['fraisResiliation'],
        'isListingActive': json['isListingActive'] == null ? undefined : json['isListingActive'],
        'brokerCollectionAllowed': json['brokerCollectionAllowed'] == null ? undefined : json['brokerCollectionAllowed'],
        'minCoeffCommercial': json['minCoeffCommercial'] == null ? undefined : json['minCoeffCommercial'],
        'maxCoeffCommercial': json['maxCoeffCommercial'] == null ? undefined : json['maxCoeffCommercial'],
        'plafondBienImmobilier': json['plafondBienImmobilier'] == null ? undefined : json['plafondBienImmobilier'],
        'nbrPrelevMin': json['nbrPrelevMin'] == null ? undefined : json['nbrPrelevMin'],
        'nbrPrelevMax': json['nbrPrelevMax'] == null ? undefined : json['nbrPrelevMax'],
        'tauxComAnneeDefault': json['tauxComAnneeDefault'] == null ? undefined : json['tauxComAnneeDefault'],
        'tauxComAnneeMin': json['tauxComAnneeMin'] == null ? undefined : json['tauxComAnneeMin'],
        'tauxComAnneeMax': json['tauxComAnneeMax'] == null ? undefined : json['tauxComAnneeMax'],
        'tauxComAnneeType': json['tauxComAnneeType'] == null ? undefined : TypeCommissionFromJSON(json['tauxComAnneeType']),
        'tauxComAnneeValeurs': json['tauxComAnneeValeurs'] == null ? undefined : json['tauxComAnneeValeurs'],
        'tauxComAnneePlusDefault': json['tauxComAnneePlusDefault'] == null ? undefined : json['tauxComAnneePlusDefault'],
        'tauxComAnneePlusMin': json['tauxComAnneePlusMin'] == null ? undefined : json['tauxComAnneePlusMin'],
        'tauxComAnneePlusMax': json['tauxComAnneePlusMax'] == null ? undefined : json['tauxComAnneePlusMax'],
        'tauxComAnneePlusType': json['tauxComAnneePlusType'] == null ? undefined : TypeCommissionFromJSON(json['tauxComAnneePlusType']),
        'tauxComAnneePlusValeurs': json['tauxComAnneePlusValeurs'] == null ? undefined : json['tauxComAnneePlusValeurs'],
        'partiesCommunes': json['partiesCommunes'] == null ? undefined : json['partiesCommunes'],
        'partiesPrivatives': json['partiesPrivatives'] == null ? undefined : json['partiesPrivatives'],
    };
}

export function FunnelDetailDtoToJSON(json: any): FunnelDetailDto {
    return FunnelDetailDtoToJSONTyped(json, false);
}

export function FunnelDetailDtoToJSONTyped(value?: FunnelDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'designation': value['designation'],
        'isActive': value['isActive'],
        'tunnelType': TypeTunnelToJSON(value['tunnelType']),
        'produit': FunnelProduitLightDtoToJSON(value['produit']),
        'formule': FunnelFormuleLightDtoToJSON(value['formule']),
        'beneficiaire': FunnelBeneficiaireDtoToJSON(value['beneficiaire']),
        'proprietaireId': value['proprietaireId'],
        'proprietaireDesignation': value['proprietaireDesignation'],
        'supports': value['supports'] == null ? undefined : ((value['supports'] as Array<any>).map(SupportTunnelDtoToJSON)),
        'garanties': value['garanties'] == null ? undefined : ((value['garanties'] as Array<any>).map(GarantieTunnelListItemDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(FunnelVariableDtoToJSON)),
        'fraisResiliation': value['fraisResiliation'],
        'isListingActive': value['isListingActive'],
        'brokerCollectionAllowed': value['brokerCollectionAllowed'],
        'minCoeffCommercial': value['minCoeffCommercial'],
        'maxCoeffCommercial': value['maxCoeffCommercial'],
        'plafondBienImmobilier': value['plafondBienImmobilier'],
        'nbrPrelevMin': value['nbrPrelevMin'],
        'nbrPrelevMax': value['nbrPrelevMax'],
        'tauxComAnneeDefault': value['tauxComAnneeDefault'],
        'tauxComAnneeMin': value['tauxComAnneeMin'],
        'tauxComAnneeMax': value['tauxComAnneeMax'],
        'tauxComAnneeType': TypeCommissionToJSON(value['tauxComAnneeType']),
        'tauxComAnneeValeurs': value['tauxComAnneeValeurs'],
        'tauxComAnneePlusDefault': value['tauxComAnneePlusDefault'],
        'tauxComAnneePlusMin': value['tauxComAnneePlusMin'],
        'tauxComAnneePlusMax': value['tauxComAnneePlusMax'],
        'tauxComAnneePlusType': TypeCommissionToJSON(value['tauxComAnneePlusType']),
        'tauxComAnneePlusValeurs': value['tauxComAnneePlusValeurs'],
        'partiesCommunes': value['partiesCommunes'],
        'partiesPrivatives': value['partiesPrivatives'],
    };
}

